import { DropdownOptionType, IDropdownMenuOption } from '@evinced-private/ui-common';

type getEvincedAppsMenuOptionsHelperArgs = {
	hasMfaLicense: boolean;
	hasMsdkLicense: boolean;
	hasSiteScannerLicense: boolean;
	hasWebSdkLicense: boolean;
	hasPlatformLicense: boolean;
	isNewDashboardEnabled: boolean;
};

export const getEvincedAppsDropdownMenuOptions = (
	licenses: getEvincedAppsMenuOptionsHelperArgs
): IDropdownMenuOption[] => {
	const {
		hasMfaLicense,
		hasMsdkLicense,
		hasSiteScannerLicense,
		hasWebSdkLicense,
		hasPlatformLicense,
		isNewDashboardEnabled
	} = licenses;
	const defaultProps = {
		type: DropdownOptionType.LINK,
		hasBottomBorder: false,
		openInNewTab: true
	};

	const appsList = [
		{
			id: 'new-dashboard-url',
			url: import.meta.env.VITE_PLATFORM_DASHBOARD_URL,
			title: 'Web Dashboard',
			active: false,
			hasLicense: isNewDashboardEnabled,
			...defaultProps
		},
		{
			id: 'wfa-dashboard-url',
			url: import.meta.env.VITE_WFA_DASHBOARD_URL,
			title: 'Web Flow Analyzer',
			active: false,
			hasLicense: hasPlatformLicense,
			...defaultProps
		},
		{
			id: 'web-sdk-dashboard-url',
			url: import.meta.env.VITE_WEB_SDK,
			title: 'Web SDKs',
			active: false,
			hasLicense: hasWebSdkLicense,
			...defaultProps
		},
		{
			id: 'site-scanner-url',
			url: import.meta.env.VITE_SITE_SCANNER_URL,
			title: 'Site Scanner',
			active: false,
			hasLicense: hasSiteScannerLicense,
			...defaultProps
		},
		{
			id: 'mfa-dashboard-url',
			url: import.meta.env.VITE_MFA_DASHBOARD_URL,
			title: 'Mobile Flow Analyzer',
			active: false,
			hasLicense: hasMfaLicense,
			...defaultProps
		},
		{
			id: 'mobile-sdk-dashboard-url',
			url: import.meta.env.VITE_MOBILE_SDK_DASHBOARD_URL,
			title: 'Mobile SDKs',
			active: false,
			hasLicense: hasMsdkLicense,
			...defaultProps
		},
		{
			id: 'product-hub',
			url: import.meta.env.VITE_PRODUCT_HUB_URL,
			title: 'Product Hub',
			active: true,
			hasLicense: true,
			...defaultProps
		},
		{
			id: 'whats-new',
			url: import.meta.env.VITE_NEW_RELEASES_URL,
			title: "What's New",
			active: false,
			hasLicense: true,
			...defaultProps
		}
	];

	return appsList.filter((app) => app.hasLicense);
};
